<template>
  <v-dialog v-model="open" @input="v => v || closeDialog()" max-width="500px">
    <v-card v-if="fieldUdp === 'user.password'">
      <v-card-title v-if="fieldText">{{ fieldText | translate }}</v-card-title>
      <v-card-text class="pb-0" v-if="sliderValues">
        <v-layout row wrap align-center justify-center>
          <v-flex xs4 md4 align-content-center>
            <v-text-field
              v-if="fieldUdp === 'user.password'"
              class="mt-0 pt-0"
              type="password"
              :value="passValue"
              v-model="passValue"
            ></v-text-field>
            <v-text-field
              v-else
              class="mt-0 pt-0"
              :value="sliderValues.val"
              v-model="sliderValues.val"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <span v-if="passValue.length < 8">{{
          "lng_password_error" | translate
        }}</span>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-btn class="raised-btn" block flat @click="dialog(false)"
              >Cancel</v-btn
            >
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-btn
              class="primary-btn"
              block
              flex
              xs12
              flat
              :disabled="passValue.length < 8"
              @click="saveFieldData()"
              >Save</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>

    <v-card v-if="fieldUdp === 'user.email'">
      <v-card-title v-if="fieldText">{{ fieldText | translate }}</v-card-title>
      <v-card-text class="pb-0" v-if="sliderValues">
        <v-layout row wrap align-center justify-center>
          <v-flex xs4 md4 align-content-center>
            <v-text-field
              class="mt-0 pt-0"
              :value="sliderValues.val"
              v-model="sliderValues.val"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-btn class="raised-btn" block flat @click="dialog(false)"
              >Cancel</v-btn
            >
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-btn
              class="primary-btn"
              block
              flex
              xs12
              flat
              :disabled="!/.+@.+/.test(this.sliderValues.val)"
              @click="saveFieldData()"
              >Save</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>

    <v-card v-if="fieldUdp !== 'user.password' && fieldUdp !== 'user.email'">
      <v-card-title v-if="fieldText">{{ fieldText | translate }}</v-card-title>
      <v-card-text class="pb-0" v-if="sliderValues">
        <v-layout row wrap align-center justify-center>
          <v-flex xs4 md4 align-content-center>
            <v-text-field
              class="mt-0 pt-0"
              :value="sliderValues.val"
              v-model="sliderValues.val"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs6 class="pr-2">
            <v-btn class="raised-btn" block flat @click="dialog(false)"
              >Cancel</v-btn
            >
          </v-flex>
          <v-flex xs6 class="pl-2">
            <v-btn
              class="primary-btn"
              block
              flex
              xs12
              flat
              @click="saveFieldData()"
              >Save</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalService from "../services/global-service.js";

export default {
  data() {
    return {
      passValue: "",
      open: false,
      sliderValues: undefined,
      fieldValues: undefined
    };
  },
  props: {
    valueObj: {
      type: Object,
      default: undefined
    },
    dialog: {
      type: Function,
      default: undefined
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    fieldText: {
      type: String,
      default: ""
    },
    fieldUdp: {
      type: String,
      default: ""
    },
    fieldDesc: {
      type: String,
      default: ""
    },
    selectedLanguage: {
      type: String,
      default: ""
    },
    onResponse: {
      type: Function,
      default: undefined
    }
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    checkField() {
      return (
        this.fieldUdp === "notify.email" || this.fieldUdp === "notify.phone"
      );
    },
    closeDialog() {
      // A prop function to open or close modal
      this.dialog(false);
    },
    // function for update field data
    async saveFieldData() {
      let response;
      try {
        response = await GlobalService.saveFieldData(
          this.fieldUdp,
          this.fieldUdp,
          this.getUser.token,
          this.fieldUdp === "user.password"
            ? this.passValue
            : this.sliderValues.val
        );
      } catch (e) {
        var resObj = { status: 1, message: "Try again later" };
        // A prop function to show alert dialog
        this.onResponse(resObj);
        // A prop function to open or close modal
        this.dialog(false);
      }
      if (response.status === "0") {
        this.fieldValues.val = this.sliderValues.val;
        this.onResponse(response);
      } else {
        this.onResponse(response);
      }

      this.dialog(false);
    }
  },
  mounted() {
    this.sliderValues = this.valueObj;
  },
  watch: {
    openDialog: function(newVal) {
      this.open = newVal;
    },
    // prop object for field values
    valueObj: function(newVal) {
      this.sliderValues = Object.assign({}, newVal);
      this.fieldValues = newVal;
    }
  }
};
</script>
<style>
.v-card__title {
  background-color: rgb(84, 110, 122);
  color: rgba(255, 255, 255, 0.87);
  font-size: 20px;
  letter-spacing: 0.005em;
  font-weight: 400;
  width: 100%;
  height: 64px;
  max-height: 64px;
  padding: 0 16px;
  margin: 0;
}
.v-input__slot {
  margin-bottom: 0;
}
.v-dialog {
  border-radius: 4px;
  overflow: hidden;
}
.raised-btn {
  background-color: rgb(250, 250, 250);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}
.primary-btn {
  background-color: rgb(84, 110, 122);
  color: #fff !important;
}
.theme--light.v-btn svg {
  fill: #455a64;
}
</style>
